
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-profile/creation",
      function () {
        return require("private-next-pages/user-profile/creation/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-profile/creation"])
      });
    }
  